import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { saveItem } from "../../services/itemService";
import {
  getCategories,
  getDropDownCategories,
} from "../../services/categoryService";

import { toast } from "react-toastify";
import BlockUi from "react-block-ui";

import Dialogue from "../common/dialogue";

class SupplierItemForm extends Form {
  state = {
    data: {
      name: "",
      code: "",
      category_id: "",
      stock: "",
      threshold: "",
    },
    categories: [],
    errors: {},
    dialogueType: "",
    dialougeTitle: "",
    dialougeDescription: "",
    dialougeVisible: "",
  };

  schema = {
    id: Joi.string(),
    name: Joi.string().required().label("Item name"),
    code: Joi.string().label("Code").allow(""),
    category_id: Joi.string().required().label("Category"),
    stock: Joi.number().label("Stock"),
    threshold: Joi.number().label("Threshold"),
  };

  async componentDidMount() {
    const { data: cats } = await getDropDownCategories();
    const categories = [{ id: "", name: "All Categories" }, ...cats];

    this.setState({ categories });
  }

  handleCancel = () => this.setState({ dialougeVisible: false });

  doSubmit = async () => {
    try {
      this.setState({ blocking: true });
      await saveItem(this.state.data);
      toast.success("Item has been added successfully.");
      this.setState({ blocking: false });
      this.props.history.push("/items");
    } catch (ex) {
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        const err = ex.response.data.errors["code"][0];
        if (err === "The code has already been taken.") {
          this.setState({
            dialogueType: "error",
            dialougeTitle: "Error",
            dialougeDescription: err,
            dialougeVisible: true,
          });
        }

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        this.setState({ errors, blocking: false });
        //toast.warning("check validation errors.");
      }
    }
  };

  render() {
    const {
      dialogueType,
      dialougeTitle,
      dialougeDescription,
      dialougeVisible,
    } = this.state;

    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <Dialogue
          type={dialogueType}
          title={dialougeTitle}
          description={dialougeDescription}
          visible={dialougeVisible}
          onCancel={this.handleCancel}
        />
        <h1 className="container__heading">Add Item</h1>
        <button
          className="btn btn--secondary"
          onClick={() => this.props.history.push("/items")}
        >
          Back
        </button>
        <form onSubmit={this.handleSubmit}>
          <div className="card form">
            <div className="form__content">
              <h3 className="card__heading">Add Item</h3>
              <p>Provide the information below to add the item.</p>
              {this.renderInput("name", "Name", "text")}
              {this.renderInput("code", "Code", "text")}
              {this.renderSelect(
                "category_id",
                "Category",
                this.state.categories
              )}

              {this.renderInput("stock", "Stock", "text")}
              {this.renderInput("threshold", "Threshold", "text")}

              {this.renderButton("Save")}
            </div>
          </div>
        </form>
      </BlockUi>
    );
  }
}

export default SupplierItemForm;
